import type { OnDestroy, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MediaObserver } from '@angular/flex-layout';
import type { IPreviewCommon } from '@shared/common/data/products';
import Books from 'src/app/data/books';
import Subscriber from 'src/app/subscriber';
import { BehaviorSubject } from 'rxjs';
import { ROUTE_PATH_BOOK_TOKYO_METRO_ALIAS_MAP } from '@shared/jp/maps';

@Component({
  selector: 'app-section-books',
  templateUrl: './section-books.component.html',
  styleUrls: ['./section-books.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionBooksComponent implements OnInit, OnDestroy {
  @Input() books = Books;

  @Input() hideTitle = false;

  @Input() disableCarousel = false;

  public readonly showCarousel = new BehaviorSubject(false);

  private readonly _sub = new Subscriber();

  constructor(
    private _router: Router,
    private _media: MediaObserver,
  ) {}

  ngOnInit(): void {
    this._sub.push(
      this._media.asObservable().subscribe(() => {
        this._updateShowCarousel();
      }),
    );
  }

  ngOnDestroy(): void {
    this._sub.unsubscribe();
  }

  private _updateShowCarousel(): void {
    this.showCarousel.next(this._media.isActive('gt-lg'));
  }

  public onButtonClick(alias: IPreviewCommon['alias']) {
    return this._router.navigate([
      ROUTE_PATH_BOOK_TOKYO_METRO_ALIAS_MAP[
        alias as keyof typeof ROUTE_PATH_BOOK_TOKYO_METRO_ALIAS_MAP
      ],
    ]);
  }
}
